import { AxiosResponse } from "axios";
import AxiosService from "./Axios";

const BASE_URL = '/tenant-bigscreen';

class TenantBigScreenApi {

    public async getTenantBigScreens(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/settings', {
            params: { tenantId: tenantId }
        });
    }

    public async updateTenantBigScreenSettings(tenantId: string, overviewType: string, deviceDetailsType: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/update-settings', {
            tenantId: tenantId,
            overviewType: overviewType,
            deviceDetailsType: deviceDetailsType,
        });
    }
}

export default TenantBigScreenApi;
